import { render } from "./Archived.vue?vue&type=template&id=752e4b83&scoped=true&lang=pug"
import script from "./Archived.vue?vue&type=script&lang=js"
export * from "./Archived.vue?vue&type=script&lang=js"

import "./Archived.vue?vue&type=style&index=0&id=752e4b83&scoped=true&lang=scss"
import "./Archived.vue?vue&type=style&index=1&id=752e4b83&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-752e4b83"]])

export default __exports__